import { createContext, useContext, useState } from 'react';
import axios from 'axios';

const PresignedUrlContext = createContext();

export const PresignedUrlProvider = ({ children }) => {
  const [urlCache, setUrlCache] = useState({}); 

  const getPresignedUrl = async (imageKey) => {
    const cached = urlCache[imageKey];

    // Check if cached URL exists and hasn't expired
    if (cached && cached.expiryTimestamp > Date.now()) {
      return cached.url;
    }

    try {
      const response = await axios.get('/api/home/getSignedUrl', {
        params: { key: imageKey },
      });

      const expiresInMs = 3600 * 1000; // 1 hour in milliseconds
      const expiryTimestamp = Date.now() + expiresInMs;

      const newEntry = {
        url: response.data.url,
        expiryTimestamp,
      };

      setUrlCache((prev) => ({
        ...prev,
        [imageKey]: newEntry,
      }));

      return response.data.url;
    } catch (error) {
      console.error('Error fetching pre-signed URL', error);
      throw error;
    }
  };

  return (
    <PresignedUrlContext.Provider value={{ getPresignedUrl }}>
      {children}
    </PresignedUrlContext.Provider>
  );
};

export const usePresignedUrl = () => useContext(PresignedUrlContext);
